<template>
  <div class="pageLiveBox">
    <!-- <Nav ref="navRef" :rType="1" :minwith='1' @routerType="changePage"></Nav> -->
    <Nav  :class="showminSlide?'showminSlide':''" ref="navRef" :minwith='1' @changeLogin='changeLogin' @routerType="changePage"></Nav>
    <div style="height: 80px" ></div>
    <div class="homeLive_content">
      <!-- 左侧分类 -->
      <div class="home-left">
        <Aside ref="MyAside" @changeAside='changeAside' @changeChildAside='changeChildAside'  :pageType='1' @Changeslide = 'Changeslide'  @login='login'></Aside>
      </div>
      <!-- 底部视频列表 -->
      <div class="rightList">
        <div class="outer-container">
          <div class="inner-container"  v-infinite-scroll="loadPages" >
            <div class="mylist"  v-loading='loadingStatus' v-if=" shouyeData && shouyeData && shouyeData.length > 0  ">
              <div class="home-right-bottom">
                <div v-for="(item, index) in shouyeData" :key="index">
                  <liveItem @login='login' :liveDetailitems='item'></liveItem>
                </div>
              </div>
            </div>
            <div class="pageLiveEmit" v-else>
              <img src="/static/nodata/emit.png" alt="" srcset="">
              <span>
                暂无内容
              </span>
            </div>
          </div>
        </div>
      </div>

    </div>
  </div>
  </div>
  </div>
  </div>
</template>
<script>
  import Nav from "../component/Nav.vue";
  import Aside from "@/components/lz_leftAside.vue";
  import liveItem from "../components/lz_liveItem.vue";
  import merge from "webpack-merge";
  import {
    categorieAllList,
    relationlives,
    streamsAll,
    historystreamsAll
  } from '@/api/lz.js'
  import axios from "axios";
  import qs from "qs";
  export default {
    components: {
      Nav,
      Aside,
      liveItem
    },
    data() {
      return {
        token: "",
        showminSlide:false,
        loadingStatus:false,
        careList: [],
        routerIndex: 1,
        imageTime: '',
        shouyeData: [],
        DataCategory: [],
        totalPage:1,
        paramsAll: {
          pcatId: 1,
          catId:'',
          pageIndex: -1,
        },
        mypageIndexstatus:true,
      };
    },
    filters: {
      ellipsis(value) {
        if (!value) return "";
        if (value.length > 10) {
          return value.slice(0, 10) + "...";
        }
        return value;
      },
      nameFilters(value) {
        if (!value) return "";
        if (value.length > 10) {
          return value.slice(0, 10) + "...";
        }
        return value;
      },
    },
    async created() {
      // this.initData();
    },
    methods: {
      login(){
        this.$refs.navRef.Longin();
      },
      Changeslide(v){
          console.log('打开关闭',v);
          this.showminSlide = v;
      },
      loadPages() {
        // 我的关注和历史记录不分页
          this.paramsAll.pageIndex += 1;
          this.reqPageList();
          console.log('开始分页', this.paramsAll.pageIndex);
      },
      reqPageList() {
        console.log('方式·1获取');
        let query = this.$route.query;
        this.mypageIndexstatus = false;
        console.log("参数", query);
        if(this.mypageIndexstatus){
          console.log('重复加载了');
          return
        }
          if (query.rid == 1 && query.infoId) {
            if (query.infoId == 999) {
              this.getrelationlives()
            } else if (query.infoId == 1000) {
              this.gethistorystreamsAll()
            } else {
              this.Fenlei1(query.infoId, query.valId ? query.valId : '');
            }
          } else {
            console.log('参数不匹配')
          }
      },
      //
      changeChildAside(obj){
        console.log('子分类',obj);

        this.$router.push({
          query: merge({
            rid: 1,
            infoId:obj.infoId,
            valId:obj.valId
          }),
        });
        this.paramsAll.pageIndex = 0;
        this.paramsAll.pcatId = obj.infoId;
        this.paramsAll.catId = obj.valId;
        this.totalPage = 1;
        this.shouyeData = []
        this.getstreamsAll()
      },
      changeAside(e) {
        console.log('方式·2获取');
        this.shouyeData = []
        switch (e) {
          case 5:
            this.paramsAll.catId = ''
            this.paramsAll.pageIndex = 0;
            this.paramsAll.pcatId = 1
            this.totalPage = 1;
            console.log('获取子分类内容',e);
            this.$router.push({
              query: merge({
                rid: 1,
                infoId: 1,
                valId: ''
              }),
            });
            this.getstreamsAll()
            break;
          case 6:
            if(!localStorage.getItem('token')){
              this.login()
              return
            }
            this.paramsAll.pageIndex = 0;
            this.totalPage = 1;
            console.log('我的关注内容');
            this.$router.push({
              query: merge({
                rid: 1,
                infoId: 999,
                valId: ""
              }),
            });
            this.getrelationlives()
            break;
          case 7:
          if(!localStorage.getItem('token')){
            this.login()
            return
          }
            this.paramsAll.pageIndex = 0;
            this.totalPage = 1;
            console.log('浏览记录内容');
            this.gethistorystreamsAll()
            this.$router.push({
              query: merge({
                rid: 1,
                infoId: 1000,
                valId: 1
              }),
            });
            break;
          default:
            break;
        }
      },
      changeLogin() {

      },
      timeOut(){
        this.loadingStatus = true;
        setTimeout(()=>{
          this.loadingStatus = false;
        },800)
      },
      // 查看浏览记录
      gethistorystreamsAll() {
        if(this.paramsAll.pageIndex > this.totalPage ){
          console.log('超过最大页码');
          return
        }
        this.loadingStatus = true;
        this.timeOut()
        historystreamsAll({}).then(res => {
          if (res.data.code == 200) {
            console.log('浏览记录', res.data.data);
            if (res.data.code == 200) {
              if (this.paramsAll.pageIndex == 0) {
                this.shouyeData = res.data.data.list;
              } else {
                this.shouyeData = res.data.data.list;
                // this.shouyeData.push(...res.data.data.list)
              }
              this.loadingStatus = false;
              this.totalPage = res.data.data.totalPage
            }
          }
        })

      },
      // 我的关注直播列表
      getrelationlives() {

        if(!localStorage.getItem('token')){
          this.login()
          return
        }
        if(this.paramsAll.pageIndex > this.totalPage ){
          console.log('超过最大页码');
          return
        }
        this.loadingStatus = true;
        this.timeOut()
        // 先登录后获取
        if (localStorage.getItem('token')) {
          relationlives({
            pageIndex: this.paramsAll.pageIndex
          }).then(res => {
            if (res.data.code == 200) {
              console.log('我的关注直播列表', res.data.data);
               if (this.paramsAll.pageIndex == 0) {
                 this.shouyeData = res.data.data.list;
               } else {
                 this.shouyeData = res.data.data.list;
                 // this.shouyeData.push(...res.data.data.list)
               }
               this.totalPage = res.data.data.totalPage
               this.loadingStatus = false;
            }
          })
        } else {
          this.$message.error('请先登录')
        }

      },
      // 获取全部直播内容
      getstreamsAll() {
        if(this.paramsAll.pageIndex > this.totalPage ){
          console.log('超过最大页码');
          return
        }
        this.loadingStatus = true;
        this.timeOut()
        streamsAll(this.paramsAll).then(res => {
          if (res.data.code == 200) {
            this.mypageIndexstatus = true;
            console.log('直播内容',res.data.data.list,this.paramsAll.pageIndex,this.paramsAll);
            if (this.paramsAll.pageIndex == 0) {
              this.shouyeData = res.data.data.list;
            } else {
              this.shouyeData.push(...res.data.data.list)
            }
            this.totalPage = res.data.data.totalPage
            this.loadingStatus = false;
          }
        })
      },
      // 分类列表
      initData() {
        // this.getstreamsAll()
        this.getcareList();

      },
      Jinruzhibojian(id, flv) {
        // console.log(id);
        // var res = this.$Utils.demoRequest(JSON.stringify(id));
        const neww = this.$router.resolve({
          path: "/roominfo",
          query: {
            roomId: id
          },
        });
        window.open(neww.href, "_self");
        // this.$router.push({name:'broadcast', params: {idasd:id}})
        // this.$router.push({name:'broadcast',params:{idasd:id}})
        // window.open(neww.href,'_blank')
        // this.$router.push(this.$route.path);
      },
      isCare(uid) {
        console.log("object 1:>> ", uid);
        let arr = this.careList.filter((item) => item.uid == uid);
        if (arr && arr.length > 0) {
          return true;
        } else {
          return false;
        }
      },
      // 获取关注列表
      getcareList() {
        this.token = localStorage.getItem("token");
        if (!this.token) {

        }
      },
      siftleave(e) {
        // console.log("离开 :>> ", e);
        // let h = e.target.children;
        // setTimeout(() => {
        //   for (let i = 0; i < h.length; i++) {
        //     if (i > 1) {
        //       h[i].children[1].style =
        //         "opacity:0;height: 0px;transition: all .6s;";
        //     }
        //   }
        // }, 390);
      },
      softEnter(e, i) {
        e.target.style = "height:auto;transition: all .3s;";
        e.target.children[1].style =
          "opacity:1;height: auto;transition: all .3s;";
        // 鼠标移动上
      },
      Fenlei1(index, id) {
        console.log('直播列表参数', index, id)
        this.$router.push({
          query: merge({
            rid: 1,
            infoId: index,
            valId: id
          })
         });

         this.paramsAll.pcatId = index;
         this.paramsAll.catId = id;
        this.getstreamsAll();
      },
      // 切换路径
      changePage(e) {
        this.routerIndex = e;
        console.log("页面路径 :>> ", e);
      },
    },
  };
</script>
<style lang="scss" scope>
  @import "../assets/style/index.scss"; //引入全局scss
  @import '../assets/style/flex.scss';
  .showminSlide{
    .bg-purple1{
      transition: all .25s !important;
      width: 64px !important;
    }
    .biglogo{
      display: none !important;
    }
    .minlogo{
      display: block !important;
    }
  }
  .outer-container{
   // background-color: #721edc;
  }
  .pageLiveBox{
    max-height: 100vh;
    overflow: hidden;
  }
  .homeLive_content {
    display: flex;
    height: calc(100vh - 92px);
    .rightList{
      background: #f6f6f6 !important;
      padding: 12px 12px 12px;
      box-sizing: border-box;
      width: 100%;
    }
  }

  .home-left {
    background: #f7f8fa;
    padding-top: 2px;
    box-shadow: 0px 2px 10px 0px rgba(46, 48, 52, 0.1);
    color: #666;

    div {
      user-select: none;
    }

    .soft_line {
      margin: 10px 0;
      height: 1px;
      width: 100%;
      background: rgba(46, 48, 52, 0.1);
    }

    .btnActive {
      color: $colorHover !important;
    }

    .home_left_soft {
      display: flex;
      flex-direction: column;
    }

    .left_item {
      width: 204px;
      display: flex;
      padding: 0 18px;
      box-sizing: border-box;
      flex-direction: column;
      justify-content: center;
      align-items: flex-start;
      height: 48px;
      transition: all 0.7s;

      // border: 1px solid red;
      .active_left {
        color: $colorHover !important;
      }

      cursor: pointer;

      .snmae {
        display: flex;
        align-items: center;
        font-size: 16px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #666666;

        div {
          margin: 0;
          height: 20px;
          line-height: 20px;
          padding: 0;
        }

        img {
          margin-right: 8px;
          width: 20px;
          height: 20px;
          // width: 100%;
        }
      }

      .soft_childre {
        display: flex;
        text-align: center;
        flex-flow: row wrap;
        padding: 2px;
        opacity: 0;
        height: 0;
        overflow: hidden;
        // box-sizing: border-box;
        // padding: 10px 0;
        transition: all 0.5s;

        .soft_childre_item {
          padding: 4px 0;
          margin: 4px 2px;
          border-radius: 4px;
          min-width: 50px;
          background-color: #f7f7f7;
          font-size: 12px;
          color: #333;
        }

        .soft_childre_item:hover {
          color: #fff;
          background-color: $colorHover;
        }
      }
    }

    .left_item:hover {
      .snmae {
        color: $colorHover;
      }
    }
  }

  .home-right-div-title {
    width: 200px;
    min-height: 21px;
  }

  .pageLiveEmit {
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;

    img {
      width: 195px;
      height: 233px;
    }

    span {
      margin-top: 22px;
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #999999;
    }
  }

  .mylist {
    flex: 2;
    background: #f6f6f6;
    padding-left: 6px;
    min-height: calc(100vh - 92px);
    box-sizing: border-box;
    overflow-y: scroll;

    .emitdata {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      height: 60vh;

      img {
        width: 300px;
        height: 164px;
      }

      .emit_txt {
        font-size: 14px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #666666;
      }
    }

    .home-right-div {
      /* height: 30%; */
      display: flex;
      height: 80px;
      flex-flow: column wrap;
      box-sizing: border-box;
      padding: 8px;

      .hotValue {
        display: flex;
        margin-top: 8px;
      }

      .video_list_img {
        width: 22px;
        height: 22px;
        margin-right: 4px;
        border-radius: 50%;
        overflow: hidden;

        img {
          width: 22px;
          height: 22px;
        }
      }
    }

    .home-right-div-title2 {
      display: flex;
      justify-content: space-between;
      flex: 2;
      align-items: center;

      .hotName {
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #666666;
        display: flex;
        align-items: center;

        img {
          margin-right: 2px;
          width: 11px;
          height: 11px;
        }
      }

      .name2 {
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #666666;
      }
    }

    .home-right-bottom {
      display: flex;
      flex-wrap: wrap;
      align-items: flex-start;
      width: 100%;
      justify-content: flex-start !important;
    }
  }

  .home-right {
    background: #f7f8fa;
    flex: 2;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;

    .video_soft_name {
      padding: 8px 20px;

      font-size: 20px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #333333;
      display: flex;
      flex-flow: row wrap;
      align-items: center;

      .name {
        font-size: 20px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #333333;
        margin-right: 12px;
      }

      .right_nav_item {
        display: flex;
        margin-right: 8px;
        padding: 2px 10px;
        align-items: center;
        height: 20px;
        line-height: 20px;
        border-radius: 10px;
        text-align: center;
        background: #d8d8d8;
        color: #666666;
        font-size: 12px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #ffffff;
      }

      .right_nav_item:hover {
        background: #721edc;
        color: #fff;
      }

      .right_nav_item_active {
        background: #721edc !important;
        color: #fff !important;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/pageLive.vue